import { AxiosResponse } from 'axios';
import { api } from '../base';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';
import { IAffectedTypeApi } from '../base/index';

const baseRoute: string = 'AffectedType';

export class AffectedTypeApi extends IAffectedTypeApi {
  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`);
  }
}
